<template>
  <div class="cling-grid" :style="gridStyle">
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'clingGrid',

  props: {
    isVisible: {
      type: Boolean,
      default: true
    },

    gridSize: {
      type: Number,
      default: -1
    }
  },

  computed: {
    ...mapState(['grid', 'video' ]),

    gridStyle: function () {
      const gridSize = this.gridSize >= 0 ? this.gridSize : this.grid.size || 10
      const videoWidth = this.video.dimensions.width || 0
      const videoHeight = this.video.dimensions.height || 0

      const horizontalOffset = (videoWidth % gridSize) / 2
      const verticalOffset = (videoHeight % gridSize) / 2
      
      const left = horizontalOffset !== 0 ? gridSize - horizontalOffset : 0
      const top = verticalOffset !== 0 ?  gridSize - verticalOffset : 0

      return {
        backgroundSize: `${gridSize}px ${gridSize}px`,
        visibility: this.isVisible ? 'visible' : 'hidden',
        width: `calc(100% + ${left}px)`,
        height: `calc(100% + ${top}px)`,
        left: `${- left}px`,
        top: `${- top}px`
      }
    }
  }
}
</script>
